import { Component, Input, OnChanges, ViewChild } from "@angular/core";
import { DateUtil } from "app/core/utils/DateUtil";

enum EWeekDay {
  Sunday,
  Monday,
  Tuesday,
  Wednesday,
  Thursday,
  Friday,
  Saturday
}

const NON_WORKING_DAY_CLASS = 'bmc-non-working-day';
const EDITED_NON_HOURS_CLASS_COMPANY = 'bmc-edited-non-hours-company';
const EDITED_HOURS_CLASS_COMPANY = 'bmc-edited-hours-company';

const EDITED_NON_WORKING_HOURS_USER = 'bmc-edited-non-working-hours-user';
const EDITED_WORKING_HOURS_USER = 'bmc-edited-working-hours-user';

const classesToCheck = [
  EDITED_HOURS_CLASS_COMPANY,
  EDITED_NON_HOURS_CLASS_COMPANY,
  EDITED_NON_WORKING_HOURS_USER,
  EDITED_WORKING_HOURS_USER
];

@Component({
  selector: 'working-time-schema-viewer',
  templateUrl: 'working-time-schema-viewer.component.html',
  styleUrls: ['working-time-schema-viewer.component.scss']
})

export class WorkingTimeSchemaViewerComponent implements OnChanges {
  @ViewChild('popupRef') popupRef: any;
  public datesCustomUserCalendarView = [];
  public workDays = [];

  public bsConfig = {
    showWeekNumbers: false
  };

  public showDetail = false;
  public isCompany = false;
  public location_top = '0px';
  public location_left = '0px';
  public workingTimeSchema;

  @Input() datesCustomUserCalendarViewInput;
  @Input() currentCalendarSelected;
  @Input() selectedUser = null;

  constructor() {}

  ngOnChanges() {
    if (this.datesCustomUserCalendarViewInput)
      this.getSpecificCalendarPerUser();
    if (this.currentCalendarSelected)
      this.setCalendar();
    else
      this.bsConfig['daysDisabled'] = [];
  }

  getSpecificCalendarPerUser() {
    this.datesCustomUserCalendarView = [];
    this.datesCustomUserCalendarView.push(...this.datesCustomUserCalendarViewInput);
  }

  setCalendar() {
    this.bsConfig['daysDisabled'] = [];
    this.calendarByDays();
    this.calendarByRange();
  }

  calendarByDays() {
    if (this.currentCalendarSelected && this.currentCalendarSelected.calendarByDays) {
      this.workDays = [];
      this.currentCalendarSelected.calendarByDays.forEach((weekday: IBaseCalendarDay) => {
        if (!weekday.isWorking)
          this.bsConfig['daysDisabled'].push(EWeekDay[weekday.weekDay]);
        else {
          this.workDays.push(weekday);
        }
      });
    }
  }

  calendarByRange() {
    if (this.currentCalendarSelected && this.currentCalendarSelected.calendarByRange) {
      this.currentCalendarSelected.calendarByRange.forEach((day: ICalendarRange) => {
        if (!day.isWorking) {
          this.datesCustomUserCalendarView.push(
            { 
              classes: [EDITED_NON_HOURS_CLASS_COMPANY, EDITED_NON_HOURS_CLASS_COMPANY + "__" + DateUtil.converDateToStringNoAddOffset(day.dateFrom)], 
              date: new Date(day.dateFrom), 
              dateToSearch: DateUtil.converDateToStringNoAddOffset(day.dateFrom),
              isCompany: true,
              workingTime: [{
                from: "00:00",
                to: "23:59"
              }]
          });
        } else {
          this.datesCustomUserCalendarView.push(
            { 
              classes: [EDITED_HOURS_CLASS_COMPANY, EDITED_HOURS_CLASS_COMPANY + "__" + DateUtil.converDateToStringNoAddOffset(day.dateFrom)], 
              date: new Date(day.dateFrom), 
              dateToSearch: DateUtil.converDateToStringNoAddOffset(day.dateFrom),
              isCompany: true,
              workingTime: day.workTimes, 
            });
        }
      });
    }
  }

  onOver(event) {
    this.location_left = `325px`;
    this.location_top = `${event.clientY-180}px`;
    if (this.selectedUser && this.selectedUser.idUser && classesToCheck.some(className => event.target.classList.contains(className))) {
      const dateToSearch = event.target.classList[1].split('__')[1];
      let dateCustom = this.datesCustomUserCalendarView.find(date => date.dateToSearch === dateToSearch);
      this.isCompany = dateCustom.isCompany;
      this.showDetail = true;
      this.workingTimeSchema = dateCustom.workingTime;
    } else if (this.selectedUser && this.selectedUser.idUser && event.target.classList.contains('is-highlighted')) {
      this.isCompany = true;
      this.showDetail = true;
      this.workingTimeSchema = this.workDays.find(day => day.weekDay === EWeekDay[event.target.parentElement['cellIndex']]).workTimes;
    } 
    else
      this.showDetail = false;
  }
  onLeave() {
    this.showDetail = false;
  }
}